import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ControlBadgeStyle } from './Styled';

export const ControlBadge = () => {
  const { t } = useExperimentsTranslations();
  return (
    <ControlBadgeStyle data-test="experiment-control-badge">{t('badge.control')}</ControlBadgeStyle>
  );
};
